import { Button } from "@faire/web--source/slate/Button";
import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import brandPortalCustomerServiceAnalytics from "@faire/web-api--source/routes/brand-portal/analytics/customer-service";
import React, { type JSX } from "react";

import { Bold } from "../common/Bold";

export const CustomerServiceAnalyticsIA = () => {
  return (
    <Column>
      <Typography>
        <StrictLocalMsg
          defaultMessage="Learn more about the quality of service you offer customers with detailed insights on the <LinkFormatting>Customer Service Analytics</LinkFormatting> page. Review your customer service performance on five metrics: late shipments, canceled orders, missing items, damaged items, and late replies. These metrics are calculated based on the last 3 months, and each metric will display a status to help you identify areas for improvement."
          values={{
            LinkFormatting: CustomerServiceAnalyticsLinkFormatting,
          }}
          description={{
            text: "Description of customer service analytics",
          }}
        />
      </Typography>
      <Spacer height="1x" />
      <Typography>
        <StrictLocalMsg
          defaultMessage="You can also dive into each success metric by reviewing the specific orders with that issue. If you find orders that you believe are being counted in error, contact us."
          description={{
            text: "Description of customer service analytics",
          }}
        />
      </Typography>
    </Column>
  );
};

const CustomerServiceAnalyticsLinkFormatting = (chunks: JSX.Element) => (
  <Button
    variant="tertiary"
    linkTo={brandPortalCustomerServiceAnalytics()}
    target="_blank"
  >
    <Bold>{chunks}</Bold>
  </Button>
);
